<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white">
    <!-- <router-link to="/general/dashboard"> -->
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Details of using the system
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Overview of Dahla Co-Act
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 pt-8 flex-auto ">
      <div class="flex flex-wrap ">
        <div class="w-full md:w-4/12 px-4 text-center">
          <div class="relative flex flex-col min-w-0 break-words bg-orange-200 w-full mb-8 shadow-md rounded-lg" >
            <div class="px-4 py-5 flex-auto">
              <div
                class="text-orange-500 text-2xl p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-5 shadow-lg rounded-full bg-white">
                <i class="fa fa-bullhorn"></i>
              </div>
              <h6 class="text-2xl font-semibold">Create Activity</h6>
              <div class="flex justify-center ">
                <div class="text-center mr-8 mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.co_act }}
                  </p>
                  <span class="text-sm font-semibold">Times</span>
                </div>

                <div class="text-center mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.co_act_hours }}
                  </p>
                  <span class="text-sm font-semibold">Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-4/12 px-4 text-center">
          <div class="relative flex flex-col min-w-0 break-words bg-orange-200 w-full mb-8 shadow-md rounded-lg">
            <div class="px-4 py-5 flex-auto">
              <div
                class="text-orange-500 text-2xl p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-5 shadow-lg rounded-full bg-white">
                <i class="fa fa-handshake"></i>
              </div>
              <h6 class="text-2xl font-semibold">Done</h6>
              <div class="flex justify-center ">
                <div class="text-center mr-8 mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.pending }}
                  </p>
                  <span class="text-sm font-semibold">Times</span>
                </div>
                <div class="text-center mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.pending_hours }}
                  </p>
                  <span class="text-sm font-semibold">Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-4/12 px-4 text-center">
          <div class="relative flex flex-col min-w-0 break-words bg-orange-200 w-full mb-8 shadow-md rounded-lg">
            <div class="px-4 py-5 flex-auto">
              <div
                class="text-orange-500 text-2xl p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-5 shadow-lg rounded-full bg-white">
                <i class="fa fa-check"></i>
              </div>
              <h6 class="text-2xl font-semibold">Approve</h6>
              <div class="flex justify-center ">
                <div class="text-center mr-8 mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.completed }}
                  </p>
                  <span class="text-sm font-semibold">Times</span>
                </div>
                <div class="text-center mt-4 p-3 items-center w-18 justify-center shadow-md rounded-lg bg-white">
                  <p class="text-5xl font-semibold">
                    {{ co_act_arr.completed_hours }}
                  </p>
                  <span class="text-sm font-semibold">Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- </router-link> -->
  </div>
</template>

<script>
import api from './../../services/student_services';

export default {
  data() {
    return {
      co_act_arr: []
    }
  },
  methods: {
    async co_act() {
      api.co_act().then(async (result) => {
        this.co_act_arr = result.data;
      });
    },
  }, created: async function () {
    await this.co_act()
  }
};
</script>

